import {
  Entity, PrimaryGeneratedColumn, Column, CreateDateColumn, UpdateDateColumn, OneToMany,
} from 'typeorm';
import { IsOptional, IsInt, IsString, IsBoolean } from 'class-validator';
import { TipoHistorico } from '../types';
import { HistoricoResposta } from '../entity/HistoricoResposta';

@Entity({name: "historicos_perguntas"})
export class HistoricoPergunta {
  @PrimaryGeneratedColumn()
  @IsOptional()
  @IsInt()
  id?: number;
  
  @Column({
    type: 'enum',
    enum: TipoHistorico,
  })
  tipo_historico: TipoHistorico;

  @Column()
  @IsString()
  nome: string;

  @Column()
  @IsOptional()
  texto_pergunta?: string | null;

  @Column()
  @IsOptional()
  opcoes?: string | null;

  @Column()
  @IsInt()
  @IsOptional()
  ordem?: number;

  @Column()
  @IsOptional()
  @IsBoolean()
  tem_observacoes?: boolean;

  @Column()
  @IsOptional()
  @IsBoolean()
  arquivada?: boolean;

  @CreateDateColumn()
  created?: Date;

  @UpdateDateColumn()
  updated?: Date;

  // RELATIONS
  @OneToMany(type => HistoricoResposta, historicos_respostas => historicos_respostas.historico_pergunta)
  historicos_respostas?: HistoricoResposta[];
}